import React from 'react';

interface PointsWarningModalProps {
  isOpen: boolean;
  currentQuestions: number;
  onSetTo20Questions: () => void;
  onContinueAnyway: () => void;
  onClose: () => void;
}

const PointsWarningModal: React.FC<PointsWarningModalProps> = ({
  isOpen,
  currentQuestions,
  onSetTo20Questions,
  onContinueAnyway,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Modal Backdrop */}
      <div 
        className="modal fade show d-block" 
        style={{ backgroundColor: 'rgba(255, 193, 7, 0.2)' }}
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow" style={{ borderRadius: '20px', border: '3px solid #ffc107' }}>
            {/* Modal Header */}
            <div className="modal-header bg-transparent border-0 p-4 pb-0">
              <div className="w-100 text-center position-relative">
                {/* Close Button */}
                <button
                  type="button"
                  className="btn-close position-absolute"
                  style={{ top: '-10px', right: '-10px' }}
                  onClick={onClose}
                  aria-label="Close"
                ></button>
                
                <div className="mb-3">
                  <div 
                    className="rounded-circle d-inline-flex align-items-center justify-content-center"
                    style={{ 
                      width: '64px', 
                      height: '64px', 
                      backgroundColor: '#ffc107',
                      color: '#ffffff'
                    }}
                  >
                    <i className="fas fa-exclamation-triangle fs-3"></i>
                  </div>
                </div>
                <h5 className="modal-title fw-bold text-warning">
                  Points Eligibility Notice
                </h5>
              </div>
            </div>

            {/* Modal Body */}
            <div className="modal-body p-4 pt-2">
              <div className="text-center mb-4">
                <p className="text-dark mb-3">
                  You've selected <strong className="text-danger">{currentQuestions} questions</strong>, but you need at least{' '}
                  <strong className="text-warning">20 questions</strong> to be eligible for earning points.
                </p>
                
                <div className="alert alert-warning border-2" style={{ borderRadius: '12px', backgroundColor: '#fff3cd', borderColor: '#ffc107' }}>
                  <div className="d-flex align-items-center">
                    <i className="fas fa-info-circle text-warning me-2 fs-5"></i>
                    <div className="text-start">
                      <strong className="text-dark d-block">Points Policy:</strong>
                      <small className="text-dark">
                        Minimum 20 questions required to earn points and compete on the leaderboard.
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="d-grid gap-2">
                <button
                  type="button"
                  className="btn btn-lg py-3"
                  style={{ 
                    background: 'linear-gradient(135deg, #28a745, #20c997)',
                    border: 'none',
                    borderRadius: '15px',
                    color: 'white'
                  }}
                  onClick={onSetTo20Questions}
                >
                  <i className="fas fa-arrow-up me-2"></i>
                  Set to 20 Questions & Earn Points
                </button>
                
                <button
                  type="button"
                  className="btn btn-outline-warning btn-lg py-3"
                  style={{ borderRadius: '15px', borderWidth: '2px' }}
                  onClick={onContinueAnyway}
                >
                  <i className="fas fa-forward me-2"></i>
                  Continue with {currentQuestions} Questions (No Points)
                </button>
                
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-lg py-3"
                  style={{ borderRadius: '15px' }}
                  onClick={onClose}
                >
                  <i className="fas fa-edit me-2"></i>
                  Let Me Change Settings
                </button>
              </div>

              <div className="text-center mt-3">
                <small className="text-muted">
                  You can always change the number of questions before generating
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PointsWarningModal;